import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getKiosk, getKiosks } from 'api/Kiosk';

export const useKiosks = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();
  return useQuery(['kiosks', ...dependencies], () => getKiosks(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options
  });
};

export const useKiosk = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();
  return useQuery(['kiosk', ...dependencies], () => getKiosk(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options
  });
};
